import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Employee } from 'src/app/models/Employees';
import { Relative } from 'src/app/models/Relative';
import { User } from 'src/app/models/Users';
import { AuthService } from 'src/app/services/auth.service';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';
import { InviteService } from 'src/app/services/modelService/invite.service';
import { RelativeService } from 'src/app/services/modelService/relative.service';
import { AlertService } from 'src/app/util/alert.service';
import { ToastService } from 'src/app/util/toast.service';
import { UtilityService } from 'src/app/util/utility.service';
import { SwimService } from '../../vansh/vansh2/swim.service';

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.page.html',
  styleUrls: ['./user-view.page.scss'],
})
export class UserViewPage implements OnInit {
  popupHeight = "300px";
  @Input() empId: string;
  emp: Employee = new Employee();
  @Output() closePopup = new EventEmitter();
  utilityService: UtilityService = new UtilityService();
  showDelete = false;

  constructor(public auth: AuthService, private swim: SwimService, private router: Router, private platform: Platform,
    public inviteService: InviteService, private alert: AlertService, private toast: ToastService,
    private relService: RelativeService, private empService: EmployeeSService) {
    this.emp.user = new User();
  }
  ngOnInit(): void {
    this.popupHeight = (this.platform.height() * .8) + "px";
    this.empService.getEmpByVariable("id", this.empId).then((emp: Employee) => {
      this.emp = emp;
      console.log("Emp", emp);
    })
  }

  clickEdit() {
    this.closePopup.emit();
    this.router.navigate(["/user-edit/" + this.emp.id]);
  }


  clickDelete() {
    this.relService.getRelative(this.emp.id, "emp_id").then((relativeList: Relative[]) => {
      let description = "Are you sure you want to delete " + this.emp.user.name + ". This will also delete his/her all relations <ul>";
      for (let rel of relativeList) {
        description += "<li><b>" + rel.relation + "</b> " + rel.name + "</li>"
      }
      description += "</ul>";

      this.alert.showAlert("Delete member", description).then(() => {
        this.relService.deleteEmpRelative(this.emp.id).then((response) => {
          console.log("Relative deleted", response);
          if (response) {
            this.empService.deleteEmployee(this.emp).then((response) => {
              if (response) {
                this.swim.deleteNode(this.emp.id);
                this.toast.success("Member deleted successfully");
                this.closePopup.emit();
              } else {
                this.toast.error("Failed to delete Member");
              }
            })
          }
        })
      })
    })
  }
  clickMerge() {
    this.closePopup.emit(this.emp);
  }
}
